module.exports = __webpack_public_path__ + "img/aus.2b5471fb.png";